// extracted by mini-css-extract-plugin
export default {"request-box":"Request_request-box__nh9W4","send-box":"Request_send-box__b27C-","error-tips":"Request_error-tips__nnAy1","disabled-btn":"Request_disabled-btn__VS4Ji"};